import { createContext } from "react";

import { withContext } from "components/contexts";

const FeeBlockContext = createContext<string>("");

export const withFeeBlockContext = withContext(FeeBlockContext);

export default FeeBlockContext;
